import http from "../helpers/http-common";

class MarketingDataService {

    getAdsNonOrganicFilters() {
        return http.get('/marketing/ads-marketing-filters');
    }

    getAdsNonOrganicData1Filters(params) {
        return http.post('/marketing/ads-marketing-data1-filters', params);
    }

    getAdsNonOrganicData2Filters(params) {
        return http.post('/marketing/ads-marketing-data2-filters', params);
    }

    getAdsNonOrganicData3Filters(params) {
        return http.post('/marketing/ads-marketing-data3-filters', params);
    }

    getAdsOrganicFilters() {
        return http.get('/marketing/ads-organic-filters');
    }

    getInstalls(params) {
        return http.post("/marketing/installs", params);
    }

    getInstallsStats(params) {
        return http.post("/marketing/installs/stats", params);
    }

    getInstallsFilters() {
        return http.get('/marketing/installs/filters');
    }

    getLeads(params) {
        return http.post('/marketing/leads', params)
    }

    getLeadsStats(params) {
        return http.post("/marketing/leads/stats", params);
    }

    getLeadsFilters() {
        return http.get('/marketing/leads/filters');
    }

    getAppUpdatesFilters() {
        return http.get("/marketing/app-updates/filters");
    }

    getAppUpdates(params) {
        return http.post("/marketing/app-updates", params);
    }

    getAppUpdatesStats(params) {
        return http.post("/marketing/app-updates/stats", params);
    }

    getAppUninstallsFilters() {
        return http.get("/marketing/app-uninstalls/filters");
    }

    getAppUninstalls(params) {
        return http.post("/marketing/app-uninstalls", params);
    }

    getAppUninstallsStats(params) {
        return http.post("/marketing/app-uninstalls/stats", params);
    }
}

export default new MarketingDataService();
